(function(){
  if (window.MylveraCartDrawerExtras) return;
  window.MylveraCartDrawerExtras = true;

  var protectionHandle = 'shipping-protection';
  var inFlight = false;
  var autoProtecting = false;
  var titleCache = {};
  var protectionOptOutKey = 'mlvShippingProtectionOptOut';

  function money(cents){
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function cartUrl(path){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function fetchCart(){
    return fetch(cartUrl('/cart.js'), {credentials:'same-origin', headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
  }

  function protectionLine(cart){
    return (cart.items || []).find(function(item){ return item.handle === protectionHandle; });
  }

  function nonProtectionCount(cart){
    return (cart.items || []).reduce(function(n,item){ return item.handle === protectionHandle ? n : n + item.quantity; }, 0);
  }

  function addVariant(variantId){
    return fetch(cartUrl('/cart/add.js'), {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:Number(variantId), quantity:1})
    }).then(function(r){return r.json();});
  }

  function changeLine(key, qty){
    return fetch(cartUrl('/cart/change.js'), {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:key, quantity:qty})
    }).then(function(r){return r.json();});
  }

  function protectionOptedOut(){
    try { return window.sessionStorage && sessionStorage.getItem(protectionOptOutKey) === '1'; }
    catch(e) { return false; }
  }

  function setProtectionOptedOut(value){
    try {
      if (!window.sessionStorage) return;
      if (value) sessionStorage.setItem(protectionOptOutKey, '1');
      else sessionStorage.removeItem(protectionOptOutKey);
    } catch(e) {}
  }

  function cleanMetaTitle(title, fallback){
    var out = String(title || fallback || '').replace(/\s*[|–—-]\s*Mylvera\s*$/i, '').trim();
    return out || fallback || '';
  }

  function normalizePath(path){
    try { return new URL(path, window.location.origin).pathname; } catch(e) { return path || ''; }
  }

  function rememberMetaTitle(path, title, fallback){
    var value = cleanMetaTitle(title, fallback);
    var key = normalizePath(path);
    if (key && value) titleCache[key] = value;
    if (path && value) titleCache[path] = value;
    return value;
  }

  function primeCurrentProductTitle(){
    if (window.location.pathname.indexOf('/products/') !== -1) {
      rememberMetaTitle(window.location.pathname, document.title, '');
    }
  }

  function fetchMetaTitle(path, fallback){
    if (!path) return Promise.resolve(cleanMetaTitle(fallback, fallback));
    var key = normalizePath(path);
    if (titleCache[path]) return Promise.resolve(titleCache[path]);
    if (titleCache[key]) return Promise.resolve(titleCache[key]);
    return fetch(path, {credentials:'same-origin', headers:{'Accept':'text/html'}})
      .then(function(r){ if (!r.ok) throw new Error('title fetch failed'); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var title = doc.querySelector('title');
        return rememberMetaTitle(path, title && title.textContent, fallback);
      })
      .catch(function(){ return cleanMetaTitle(fallback, fallback); });
  }

  function hideProtectionLineInDrawer(){
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.querySelectorAll('.cart__item').forEach(function(item){
      var link = item.querySelector('a[href*="/products/' + protectionHandle + '"]');
      var name = item.querySelector('.cart__item-name');
      var isProtection = !!link || (name && /shipping protection/i.test(name.textContent || ''));
      item.classList.toggle('mlv-cart-hidden-protection', isProtection);
      if (isProtection) item.setAttribute('aria-hidden', 'true');
    });
  }

  function updateDrawerItemTitles(){
    // Product titles in the cart drawer should stay as Shopify product.title.
    // Do not replace them with SEO/meta titles fetched from product pages.
    return;
  }

  function observeCartDrawer(){
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.mlvProtectionObserver === '1' || !window.MutationObserver) return;
    drawer.dataset.mlvProtectionObserver = '1';
    new MutationObserver(function(){
      hideProtectionLineInDrawer();
      updateDrawerItemTitles();
    }).observe(drawer, {childList:true, subtree:true});
  }

  function maybeAutoEnableProtection(root, cart){
    // Legacy theme protection stays user-controlled. Kaching CartDrawer owns any configured auto-add.
    return false;
  }

  function updateProtection(root, cart){
    var box = root.querySelector('[data-mlv-cart-protection]');
    var btn = root.querySelector('[data-mlv-protection-toggle]');
    if (!box || !btn) return;
    var hasNormalItems = nonProtectionCount(cart) > 0;
    var line = protectionLine(cart);
    box.hidden = !hasNormalItems;
    box.classList.toggle('is-on', !!line);
    var addLabel = btn.getAttribute('data-mlv-protection-add-label') || 'Add Shipping Protection';
    var removeLabel = btn.getAttribute('data-mlv-protection-remove-label') || 'Remove Shipping Protection';
    btn.setAttribute('aria-pressed', line ? 'true' : 'false');
    btn.setAttribute('aria-label', line ? removeLabel : addLabel);
    btn.dataset.lineKey = line ? line.key : '';
  }

  function applyProtectionCartUpdate(cart){
    hideProtectionLineInDrawer();
    updateDrawerItemTitles();
    document.querySelectorAll('[data-subtotal]').forEach(function(el){
      var formatted=money(cart&&cart.total_price);if(/<[^>]+>/.test(formatted)){el.innerHTML=formatted}else{el.textContent=formatted};
    });
    document.querySelectorAll('[data-mlv-cart-extras="protection"]').forEach(function(root){
      updateProtection(root, cart || {items:[]});
    });
  }

  function updateAll(){
    observeCartDrawer();
    hideProtectionLineInDrawer();
    updateDrawerItemTitles();
    var roots = document.querySelectorAll('[data-mlv-cart-extras]');
    if (!roots.length) return;
    fetchCart().then(function(cart){
      hideProtectionLineInDrawer();
      updateDrawerItemTitles();
      if (nonProtectionCount(cart) <= 0) setProtectionOptedOut(false);
      roots.forEach(function(root){
        if (maybeAutoEnableProtection(root, cart)) return;
        updateProtection(root, cart);
      });
    });
  }

  document.addEventListener('click', function(evt){
    var toggle = evt.target.closest('[data-mlv-protection-toggle]');
    if (!toggle) return;
    evt.preventDefault();
    if (inFlight) return;
    inFlight = true;
    var root = evt.target.closest('[data-mlv-cart-extras]');
    toggle.disabled = true;
    var lineKey = toggle.dataset.lineKey;
    var variantId = root && root.dataset.protectionVariantId;
    var box = root && root.querySelector('[data-mlv-cart-protection]');
    if (box) box.classList.toggle('is-on', !lineKey);
    setProtectionOptedOut(!!lineKey);
    var action = lineKey ? changeLine(lineKey, 0) : addVariant(variantId).then(fetchCart);
    action.then(function(cart){
        applyProtectionCartUpdate(cart);
        setTimeout(function(){ applyProtectionCartUpdate(cart); }, 120);
      })
      .catch(function(){ window.location.reload(); })
      .finally(function(){ inFlight = false; toggle.disabled = false; });
  });

  document.addEventListener('page:loaded', updateAll);
  document.addEventListener('ajaxProduct:added', function(){ setTimeout(updateAll, 350); });
  document.addEventListener('cart:updated', function(){ setTimeout(updateAll, 350); });
  document.addEventListener('cart:build', function(){ hideProtectionLineInDrawer(); updateDrawerItemTitles(); setTimeout(function(){ hideProtectionLineInDrawer(); updateDrawerItemTitles(); }, 100); setTimeout(function(){ hideProtectionLineInDrawer(); updateDrawerItemTitles(); }, 450); });
  // Kaching CartDrawer: default ON once per Shopify cart, then respect a manual OFF.
  var kachingBridgeClicking = false;
  var kachingManualOptOut = false;
  var kachingCartToken = 'session';

  function kachingStorageKey(kind){
    return 'mlvKachingProtection' + kind + ':' + kachingCartToken;
  }

  function getKachingState(kind){
    try { return window.sessionStorage && sessionStorage.getItem(kachingStorageKey(kind)) === '1'; }
    catch(e) { return false; }
  }

  function setKachingState(kind, value){
    try {
      if (!window.sessionStorage) return;
      if (value) sessionStorage.setItem(kachingStorageKey(kind), '1');
      else sessionStorage.removeItem(kachingStorageKey(kind));
    } catch(e) {}
  }

  function refreshKachingCartContext(){
    return fetchCart().then(function(cart){
      kachingCartToken = cart.token || 'session';
      if (nonProtectionCount(cart) <= 0) {
        setKachingState('Initialized', false);
        setKachingState('OptOut', false);
        kachingManualOptOut = false;
      }
      return cart;
    });
  }

  function defaultKachingProtectionOn(){
    refreshKachingCartContext().then(function(cart){
      if (nonProtectionCount(cart) <= 0 || kachingManualOptOut || getKachingState('OptOut') || getKachingState('Initialized')) return;
      var attempts = 0;
      var timer = setInterval(function(){
        attempts += 1;
        var toggle = document.querySelector('.kaching-cart-toggle');
        if (toggle) {
          setKachingState('Initialized', true);
          if (!toggle.classList.contains('kaching-cart-toggle__active')) {
            kachingBridgeClicking = true;
            toggle.click();
            kachingBridgeClicking = false;
          }
          clearInterval(timer);
          return;
        }
        if (attempts >= 100) clearInterval(timer);
      }, 200);
    }).catch(function(){});
  }

  document.addEventListener('click', function(evt){
    var toggle = evt.target.closest && evt.target.closest('.kaching-cart-toggle');
    if (!toggle || kachingBridgeClicking) return;
    var turningOff = toggle.classList.contains('kaching-cart-toggle__active');
    kachingManualOptOut = turningOff;
    refreshKachingCartContext().then(function(){
      setKachingState('Initialized', true);
      setKachingState('OptOut', turningOff);
    }).catch(function(){});
  }, true);

  document.addEventListener('kaching-cart:open', function(){ setTimeout(defaultKachingProtectionOn, 0); });
  defaultKachingProtectionOn();

  primeCurrentProductTitle();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ primeCurrentProductTitle(); updateAll(); }); else updateAll();
})();
